import { render, staticRenderFns } from "./PromoTemplateModal.vue?vue&type=template&id=1b005927&scoped=true&"
import script from "./PromoTemplateModal.vue?vue&type=script&lang=js&"
export * from "./PromoTemplateModal.vue?vue&type=script&lang=js&"
import style0 from "./PromoTemplateModal.vue?vue&type=style&index=0&id=1b005927&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b005927",
  null
  
)

export default component.exports